import React, { useContext, useRef, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { CustomProvider, DatePicker, DateRangePicker } from "rsuite";
import CubeTimeDimensionRange from "./range";
import {
  Box,
  Button,
  Grid,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
  Chip,
  alpha,
  useTheme,
  Menu,
} from "@mui/material";
import Stack from "@mui/material/Stack";
import {
  ButtonGroup,
  ClickAwayListener,
  Grow,
  Paper,
  Popper,
  MenuList,
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
const options = ["Option 1", "Option 2", "Option 3", "Option 4"];
function CubeTimeDimensionSelector({
  timeGranularity,
  setTimeGranularity,
  setTimeDimensions,
  setMeasureType,
}: any) {
  const theme = useTheme();

  const [open, setOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const anchorRef = useRef<HTMLDivElement>(null);

  const handleClick = () => {
    console.log(`You selected: ${options[selectedIndex]}`);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
    index: React.SetStateAction<number>
  ) => {
    setSelectedIndex(index);
    setOpen(false);
  };

  const handleClose = (event: { target: any }) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const { selcetedPlant }: any = useSelector(
    (state: any) => state.selectedPlantIM
  );
  const plantTimeZone = selcetedPlant?.plant_timezone;
  const range = [
    moment
      .tz("America/Los_Angeles")
      .subtract(12, "hours")
      .subtract(moment().tz(plantTimeZone)?.utcOffset(), "minutes")
      .format("YYYY-MM-DDTHH:mm:ss.000"),
    moment
      .tz("America/Los_Angeles")
      .subtract(moment().tz(plantTimeZone)?.utcOffset(), "minutes")
      .format("YYYY-MM-DDTHH:mm:ss.000"),
  ];

  const [dateRange, setDateRange] = React.useState<any>(range);
  const [dateRangeFilterLabel, setDateRangeFilterLabel] =
    React.useState("Last 12 hours");
  const d1 = new Date(
    moment.utc().subtract(1, "days").format("YYYY-MM-DDTHH:mm:ss.000")
  );
  const d2 = new Date(moment.utc().format("YYYY-MM-DDTHH:mm:ss.000"));
  const [startDateState, setStartDateState] = React.useState<Date>(d1);
  const [endDateState, setEndDateState] = React.useState<Date>(d2);
  const [measure, setMeasure] = React.useState<any>("lastValue");
  const [cubeMatchingString, setCubeMatchingString] =
    React.useState<any>("FiveMinAgg");

  const handleRangeChange = (range: any, difference: any) => {
    const currentDate = moment.utc();
    let granularity = "";
    let cubeType = "";
    if (
      difference <= 14 &&
      Math.abs(moment(range[0]).diff(currentDate, "days")) <= 14
    ) {
      setMeasure("lastValue");
      setCubeMatchingString("FiveMinAgg");
      setMeasure("lastValue");

      // contextProps.correspondingCubes.find((cube: any) => {
      // 	return (
      // 		cube.name.includes('FiveMinAgg') && !cube.name.includes('Actionable')
      // 	)
      // })

      // contextProps.correspondingCubes.find((cube: any) => {
      // 	return (
      // 		cube.name.includes('FiveMinAgg') && cube.name.includes('Actionable')
      // 	)
      // })
      granularity = "minute";
      cubeType = "FiveMinAgg";
    } else if (
      difference <= 90 &&
      Math.abs(moment(range[0]).diff(currentDate, "days")) <= 90
    ) {
      setCubeMatchingString("HourlyAgg");
      setMeasure("avgValue");
      // contextProps.correspondingCubes.find((cube: any) => {
      // 	return (
      // 		cube.name.includes('HourlyAgg') && !cube.name.includes('Actionable')
      // 	)
      // })

      // contextProps.correspondingCubes.find((cube: any) => {
      // 	return (
      // 		cube.name.includes('HourlyAgg') && cube.name.includes('Actionable')
      // 	)
      // })
      granularity = "hour";
      cubeType = "HourlyAgg";
    } else {
      setMeasure("avgValue");
      setCubeMatchingString("DailyAgg");
      setMeasure("avgValue");

      // contextProps.correspondingCubes.find((cube: any) => {
      // 	return (
      // 		cube.name.includes('DailyAgg') && !cube.name.includes('Actionable')
      // 	)
      // })

      // contextProps.correspondingCubes.find((cube: any) => {
      // 	return (
      // 		cube.name.includes('DailyAgg') && cube.name.includes('Actionable')
      // 	)
      // })
      granularity = "day";
      cubeType = "DailyAgg";
    }
    setTimeGranularity(granularity);
    setTimeDimensions(range);
    setMeasureType(cubeType);

    // setDateRange([startDate, endDate])
  };
  const handleDateRangeFilter = (item: any) => {
    if (item !== "custom") {
      const _MS_PER_DAY = 1000 * 60 * 60 * 24;
      const temp1 = new Date(
        moment()
          .tz("America/Los_Angeles")
          .subtract(item.difference.value, item.difference.unit)
          .format("YYYY-MM-DDTHH:mm:ss.000")
      );
      const temp2 = new Date(
        moment().tz("America/Los_Angeles").format("YYYY-MM-DDTHH:mm:ss.000")
      );
      setStartDateState(temp1);
      setEndDateState(temp2);
      const difference: any = (temp2.valueOf() - temp1.valueOf()) / _MS_PER_DAY;
      handleRangeChange(
        [
          moment()
            .tz("America/Los_Angeles")
            .subtract(item.difference.value, item.difference.unit)
            .format("YYYY-MM-DDTHH:mm:ss.000"),
          moment().tz("America/Los_Angeles").format("YYYY-MM-DDTHH:mm:ss.000"),
        ],
        difference
      );
    }
  };
  return (
    <>
      <ButtonGroup
        variant="contained"
        ref={anchorRef}
        aria-label="Custom select button"
      >
        <Button
          sx={{
            width: 'auto',
            height: 35,
            padding: " 0 10px",
            borderRadius: 1,
            backgroundColor: alpha(theme.palette.primary.main, 0.3),
            color: "white",
            "&:hover": {
              backgroundColor: "primary.dark",
            },
            borderRightColor: "1px solid #232a58 !important"
          }}
          onClick={handleClick}
        >
          {dateRangeFilterLabel}
        </Button>
        <Button
          size="small"
          aria-controls={open ? "split-button-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="menu"
          onClick={handleToggle}
          sx={{
            width: 40,
            height: 35,
            padding: " 0 10px",
            borderRadius: 1,
            backgroundColor: alpha(theme.palette.primary.main, 0.3),
            color: "white",
            "&:hover": {
              backgroundColor: "primary.dark",
            },
          }}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>

      {dateRangeFilterLabel === "custom" ? (
        <CustomProvider theme="dark">
          <DateRangePicker
            showOneCalendar
            defaultValue={[startDateState, endDateState]}
            value={[startDateState, endDateState]}
            placeholder="Set Date Range"
            onChange={(value: any, event: any) => {
              //condition to run on clearing the date in date picker
              if (value === null) {
                const d1 = new Date(
                  moment()
                    .tz("America/Los_Angeles")
                    .subtract(1, "days")
                    .subtract(
                      moment().tz(plantTimeZone).utcOffset(),
                      "minutes"
                    )
                    .format("YYYY-MM-DDTHH:mm:ss.000")
                );
                const d2 = new Date(
                  moment()
                    .tz("America/Los_Angeles")
                    .subtract(
                      moment().tz(plantTimeZone).utcOffset(),
                      "minutes"
                    )
                    .format("YYYY-MM-DDTHH:mm:ss.000")
                );
                setStartDateState(d1);
                setEndDateState(d2);
                const range = [
                  moment()
                    .tz("America/Los_Angeles")
                    .subtract(1, "days")
                    .format("YYYY-MM-DDTHH:mm:ss.000"),
                  moment()
                    .tz("America/Los_Angeles")
                    .format("YYYY-MM-DDTHH:mm:ss.000"),
                ];
                const _MS_PER_DAY = 1000 * 60 * 60 * 24;
                const difference: any =
                  (d2.valueOf() - d1.valueOf()) / _MS_PER_DAY;
                handleRangeChange(range, difference);
              } else {
                const d1 = new Date(value[0]);
                const d2 = new Date(value[1]);
                setStartDateState(d1);
                setEndDateState(d2);
                //custom logic for last 12 hours
                if (event.target.outerText === "Last 12 hours") {
                  const range = [
                    moment(d2)
                      .tz("America/Los_Angeles")
                      .subtract(12, "hours")
                      .format(),
                    moment(d2).tz("America/Los_Angeles").format(),
                  ];
                  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
                  const difference: any =
                    (d2.valueOf() - d1.valueOf()) / _MS_PER_DAY;
                  handleRangeChange(range, difference);
                }
                //custom logic for last 24 hours
                else if (event.target.outerText === "Last 24 hours") {
                  const range = [
                    moment(d2)
                      .tz("America/Los_Angeles")
                      .subtract(24, "hours")
                      .format(),
                    moment(d2).tz("America/Los_Angeles").format(),
                  ];
                  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
                  const difference: any =
                    (d2.valueOf() - d1.valueOf()) / _MS_PER_DAY;
                  handleRangeChange(range, difference);
                }
                //custom logic for last 2 days
                else if (event.target.outerText === "Last 2 days") {
                  const range = [
                    moment(d2)
                      .tz("America/Los_Angeles")
                      .subtract(48, "hours")
                      .format(),
                    moment(d2).tz("America/Los_Angeles").format(),
                  ];
                  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
                  const difference: any =
                    (d2.valueOf() - d1.valueOf()) / _MS_PER_DAY;
                  handleRangeChange(range, difference);
                } else {
                  //condition based logic to handle if same date is selected as start and end date or not
                  //   const range =
                  //     moment(d1)
                  //       .tz("America/Los_Angeles")
                  //       .startOf("day")
                  //       .subtract(
                  //         moment().tz(plantTimeZone).utcOffset(),
                  //         "minutes"
                  //       )
                  //       .format() ===
                  //     moment(d2)
                  //       .tz("America/Los_Angeles")
                  //       .startOf("day")
                  //       .subtract(
                  //         moment().tz(plantTimeZone).utcOffset(),
                  //         "minutes"
                  //       )
                  //       .format()
                  //       ? //in case same date is selected- use selected date and selected date plus one day
                  //         [
                  //           moment(d1)
                  //             .tz("America/Los_Angeles")
                  //             .startOf("day")
                  //             .format("YYYY-MM-DDTHH:mm:ss.000"),
                  //           moment(d1)
                  //             .tz("America/Los_Angeles")
                  //             .startOf("day")
                  //             .add(1, "days")
                  //             .format("YYYY-MM-DDTHH:mm:ss.000"),
                  //         ]
                  //       : //in case different dates are selected
                  //         [
                  //           moment(d1)
                  //             .tz("America/Los_Angeles")
                  //             .startOf("day")
                  //             .format("YYYY-MM-DDTHH:mm:ss.000"),
                  //           moment(d2)
                  //             .tz("America/Los_Angeles")
                  //             .startOf("day")
                  //             .add(1439, "minutes")
                  //             .format("YYYY-MM-DDTHH:mm:ss.000"),
                  //         ];
                  const range = [
                    moment(d1)
                      .tz("America/Los_Angeles")
                      .format("YYYY-MM-DDTHH:mm:ss.000"),
                    moment(d2)
                      .tz("America/Los_Angeles")
                      .format("YYYY-MM-DDTHH:mm:ss.000"),
                  ];
                  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
                  const difference: any =
                    (d2.valueOf() - d1.valueOf()) / _MS_PER_DAY;
                  handleRangeChange(range, difference);
                }
              }
            }}
            size="lg"
          />
        </CustomProvider>
      ) : (
        <></>
      )}

      <Popper
        {...({
          sx: { zIndex: 1 },
          open,
          anchorEl: anchorRef.current,
          role: undefined,
          transition: true,
          disablePortal: true,
        } as any)}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {CubeTimeDimensionRange(plantTimeZone).map((ele: any) => (
                    <MenuItem
                      key={ele?.id}
                      value={ele.label}
                      onClick={() => {
                        handleDateRangeFilter(ele);
                        setDateRangeFilterLabel(ele.label);
                        setTimeDimensions(ele.value);
                        setSelectedIndex(ele.index);
                        setOpen(false);
                      }}
                    //onClick={(event) => handleMenuItemClick(event, index)}
                    >
                      {ele.label}
                    </MenuItem>
                  ))}
                  <MenuItem
                    value="custom"
                    onClick={() => {
                      handleDateRangeFilter("custom");
                      setDateRangeFilterLabel("custom");
                    }}
                  >
                    Custom DateRange
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
      {/* <Stack direction="row" spacing={1}>
          <FormControl margin="dense" variant="outlined">
            <InputLabel id="demo-simple-select-outlined-label">
              Select Date Range
            </InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              label="Type"
              inputProps={{ "data-testid": "filter-input" }}
              value={dateRangeFilterLabel}
            >
              {CubeTimeDimensionRange(plantTimeZone).map((ele: any) => {
                return (
                  <MenuItem
                    key={ele?.id}
                    value={ele.label}
                    onClick={() => {
                      handleDateRangeFilter(ele);
                      setDateRangeFilterLabel(ele.label);
                      setTimeDimensions(ele.value);
                    }}
                  >
                    {ele.label}
                  </MenuItem>
                );
              })}
              <MenuItem
                value="custom"
                onClick={() => {
                  handleDateRangeFilter("custom");
                  setDateRangeFilterLabel("custom");
                }}
              >
                Custom{" "}
              </MenuItem>
            </Select>
          </FormControl>
        
          <Tooltip title={"Granularity"}>
            <Chip
              size="medium"
              color="primary"
              label={
                timeGranularity === "minute"
                  ? "5 Minute"
                  : timeGranularity === "hour"
                    ? "Hourly"
                    : "Daily"
              }
              sx={{
                height: "50px",
              }}
            />
          </Tooltip>
        </Stack> */}
    </>
  );
}

export default CubeTimeDimensionSelector;
